import React from 'react';
import {
    FloorplanSmall,
    DocumentSmall,
    ExternallinkSmall
} from '@blueprint/icons';
import { CTALink } from 'listing-details/components/CTA/CTA';
import Gallery from 'shared/components/Gallery/Gallery';
import { FloorPlansProps } from './FloorPlans.types';
import { mapPropertyImageResponseToGalleryImages } from 'listing-details/helpers';
import { mapLinksAndPDFsToExternal } from './FloorPlans.helpers';
import {
    ModalGalleryContainer,
    FloorPlanExternalList,
    FloorPlanExternalItem
} from './FloorPlans.styles';
import {
    trackNextFloorPlan,
    trackPreviousFloorPlan,
    trackFloorPlanExternalItemClick,
    trackZoomFloorPlan
} from './FloorPlans.tracking';

const FloorPlans = ({ data }: FloorPlansProps) => {
    const floorPlans = data.floorPlan;

    const images = mapPropertyImageResponseToGalleryImages(
        '(min-width: 1500px) 1280px, (min-width: 960px) 85vw, 100vw',
        floorPlans?.image || []
    );

    const external = mapLinksAndPDFsToExternal(
        floorPlans?.pdf || [],
        floorPlans?.links || []
    );

    if (images.length) {
        return (
            <ModalGalleryContainer>
                <Gallery
                    images={images}
                    icon={<FloorplanSmall />}
                    createCaption={(index, total) =>
                        `Floor plan ${index + 1} of ${total}. ${
                            images[index].alt
                        }`
                    }
                    hasZoomControls={true}
                    onSlideNext={trackNextFloorPlan}
                    onSlidePrevious={trackPreviousFloorPlan}
                    onSlideZoom={trackZoomFloorPlan}
                />
            </ModalGalleryContainer>
        );
    } else if (external.length) {
        return (
            <FloorPlanExternalList data-testid="external-list">
                {external.map((item, index) => (
                    <FloorPlanExternalItem key={item.url}>
                        <CTALink
                            href={item.url}
                            target="_blank"
                            label={item.caption || 'Floor plan'}
                            icon={<FloorplanSmall />}
                            iconAction={
                                item.type === 'pdf' ? (
                                    <DocumentSmall data-testid="icon-pdf" />
                                ) : (
                                    <ExternallinkSmall data-testid="icon-link" />
                                )
                            }
                            onClick={() =>
                                trackFloorPlanExternalItemClick(
                                    index,
                                    item.type
                                )
                            }
                        />
                    </FloorPlanExternalItem>
                ))}
            </FloorPlanExternalList>
        );
    }

    return <></>;
};

export default FloorPlans;
